export default __webpack_public_path__ + "static/media/resturant-menu-theme-2.3e4d5ade.jpg";